(() => {
  const SECTION_CLASS = "store-locations-section";

  const getSectionId = (section) => section.id.replace("shopify-section-", "");

  const initSection = (section) => {
    if (!section || !section.classList.contains(SECTION_CLASS)) return;
    if (typeof window.initArrowMoveOnHover !== "function") return;

    window.initArrowMoveOnHover(section, ".store-locations__card");
  };

  // ModalDialog relocates each popup to <body> on connect, so removing the
  // section leaves them behind. A re-render re-attaches them (same block ids),
  // which is why the section has to be gone before we clean up.
  const removeOrphanModals = (sectionId) => {
    if (document.getElementById(`shopify-section-${sectionId}`)) return;

    document
      .querySelectorAll(
        `body > modal-dialog.store-location-modal[data-section-id="${sectionId}"]`
      )
      .forEach((modal) => {
        if (typeof modal.hide === "function") modal.hide();
        modal.remove();
      });
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", (event) => {
    initSection(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const section = event.target;
    if (!section || !section.classList.contains(SECTION_CLASS)) return;

    const sectionId = getSectionId(section);
    requestAnimationFrame(() => removeOrphanModals(sectionId));
  });
})();
